import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const UserFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M12.9 11.91h-1.8c-4.4 0-7.99 3.57-7.99 7.94v.89H20.9v-.89c0-4.37-3.6-7.94-7.99-7.94h-.01ZM12 11.41a4.08 4.08 0 1 0 0-8.16 4.08 4.08 0 0 0 0 8.16Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default UserFilled
